import { MutableRefObject, JSX, useState } from 'react';
import { IModalProps, ModalName, t, GameId, partnerSettingsStore } from '@bg-shared';
import { Modal } from '@bg-components/Modal';
import { HistoryIcon } from '@bg-components/Icon';
import { ModalContent } from '@bg-components/Modal/ModalContent';
import { PagesModalHeader } from '@bg-components/Modals/components/PagesModalHeader';
import { ReportSkeleton } from '@bg-components/Reports/components/ReportSkeleton/ReportSkeleton';
import { LazyRoute } from '@bg-components/LazyRoute';
import { fadeAnimation } from '@bg-components/Modals/constants/fadeAnimation';
import { BetHistoryReport } from '@bg-components/Reports/pages/BetHistoryReport';
import { SubscriptionReport } from '@bg-components/Reports/pages/SubscriptionReport';
import classes from './BetHistoryModal.module.scss';

interface IProps extends IModalProps {
    gameId: GameId | null;
    subscriptionId?: number;
    openerElementRef?: MutableRefObject<HTMLElement>;
}

export const BetHistoryModal = ({ subscriptionId = null, ...props }: IProps): JSX.Element => {
    const gameId = props.gameId || partnerSettingsStore.availableGamesIds[0];
    const [showSubscriptionReport, setShowSubscriptionReport] = useState<boolean>(!!subscriptionId);

    return (
        <Modal
            modalName={ModalName.BET_HISTORY}
            onClose={props.onClose}
            animation={fadeAnimation}
            openerElementRef={props.openerElementRef}
            className={classes.modal}
        >
            <PagesModalHeader
                title={t.string('bet_history')}
                icon={HistoryIcon}
                onClose={props.onClose}
            />
            <ModalContent>
                <LazyRoute Fallback={<ReportSkeleton rowsCount={3} />}>
                    {showSubscriptionReport ? (
                        <SubscriptionReport
                            id={subscriptionId}
                            gameId={gameId}
                            onBack={() => {
                                setShowSubscriptionReport(false);
                            }}
                        />
                    ) : (
                        <BetHistoryReport gameId={gameId} />
                    )}
                </LazyRoute>
            </ModalContent>
        </Modal>
    );
};
